/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Keyword_ResearchInputs */

const en_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword research`)
};

const ar_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث الكلمات المفتاحية`)
};

const bn_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কীওয়ার্ড গবেষণা`)
};

const de_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword-Recherche`)
};

const es_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investigación de palabras clave`)
};

const fr_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche de mots-clés`)
};

const pt_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa de palavras-chave`)
};

const zh_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键词研究`)
};

const tr_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar kelime araştırması`)
};

const ru_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исследование ключей`)
};

const pl_svchip_keyword_research = /** @type {(inputs: Svchip_Keyword_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research słów kluczowych`)
};

/**
* | output |
* | --- |
* | "Keyword research" |
*
* @param {Svchip_Keyword_ResearchInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_keyword_research = /** @type {((inputs?: Svchip_Keyword_ResearchInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Keyword_ResearchInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_keyword_research(inputs)
	if (locale === "bn") return bn_svchip_keyword_research(inputs)
	if (locale === "de") return de_svchip_keyword_research(inputs)
	if (locale === "es") return es_svchip_keyword_research(inputs)
	if (locale === "fr") return fr_svchip_keyword_research(inputs)
	if (locale === "pt") return pt_svchip_keyword_research(inputs)
	if (locale === "zh") return zh_svchip_keyword_research(inputs)
	if (locale === "tr") return tr_svchip_keyword_research(inputs)
	if (locale === "ru") return ru_svchip_keyword_research(inputs)
	if (locale === "pl") return pl_svchip_keyword_research(inputs)
	return en_svchip_keyword_research(inputs)
});